import { DesktopFieldPreview } from './DesktopFieldPreview';

export default DesktopFieldPreview;
